import React, { ReactElement, useState } from "react";
import CardActions from '@mui/material/CardActions';
import QuestionBox from "../box";
import QuestionValue from "../value";
import { PercentQuestionSpec, QuestionEditorProps, Value } from '../../../types/types';
import QuestionEditorButton from "../questioneditorbutton";
import QuestionLabel from '../label';
import PercentFieldEditor from '../../field/editors/percentfieldeditor';

function PercentQuestionEditor(props: QuestionEditorProps<PercentQuestionSpec>) : ReactElement {
  const [value, setValue] = useState<Value>(props.answer?.value);

  return (
    <QuestionBox>
      <QuestionLabel spec={props.spec} />
      <QuestionValue>
        <PercentFieldEditor specs={props.spec as PercentQuestionSpec} value= {value as number} setValue={setValue}/>
      </QuestionValue>
      <CardActions>
        <QuestionEditorButton response={value} setResponse={setValue} defaultValue={props.answer?.value} buttonsSettings={props.buttonsSettings} />
      </CardActions>
    </QuestionBox>
  );
}
export default PercentQuestionEditor;
